import {
  Grid,
  TextInput,
  Button,
  Checkbox,
  Text,
  Select,
  CloseButton,
} from "@mantine/core";
import { showNotification } from "@mantine/notifications";
import { IconPlus } from "@tabler/icons";
import { useState, useEffect } from "react";
import { useSetState } from "@mantine/hooks";

export default function RadioField(props) {
  const [values, setValues] = useSetState({
    ...props.field.initialValues,
  });

  const [answers, setAnswers] = useState([
    ...props.field.initialValues.answers,
  ]);

  useEffect(() => {
    props.setFieldValues(props.field.id, values);
  }, [values]);

  useEffect(() => {
    setValues({
      answers: [...answers],
    });
  }, [answers]);

  return (
    <Grid gpas={"xl"}>
      <Grid.Col span={12}>
        <Checkbox
          label="Required"
          defaultValue={props.field.initialValues.required}
          onChange={(e) => setValues({ required: e.currentTarget.checked })}
        />
      </Grid.Col>
      <Grid.Col span={6}>
        <TextInput
          placeholder="Field Label"
          variant="filled"
          onChange={(e) => setValues({ label: e.currentTarget.value })}
        />
      </Grid.Col>
      <Grid.Col span={6}>
        <TextInput
          placeholder="Field Translation"
          variant="filled"
          onChange={(e) => setValues({ translation: e.currentTarget.value })}
        />
      </Grid.Col>
      <Grid.Col span={6}>
        <Select
          placeholder="Default Value"
          variant="filled"
          searchable
          data={answers.filter(
            (value, index) => value.length && answers.indexOf(value) === index
          )}
          onChange={(val) => setValues({ defaultValue: val })}
        />
      </Grid.Col>
      <Grid.Col span={6}>
        <TextInput
          placeholder="Placeholder (Default value is field label)"
          variant="filled"
          onChange={(e) => setValues({ placeholder: e.currentTarget.value })}
        />
      </Grid.Col>
      <Grid.Col span={12}>
        <Select
          placeholder="Chart Type"
          variant="filled"
          description="Select the type of chart you want to display on the dashboard"
          defaultValue={props.field.initialValues.chartType}
          searchable
          data={[
            {
              value: "pi",
              label: "Pi Chart",
            },
            {
              value: "bar",
              label: "Bar Chart",
            },
            {
              value: "none",
              label: "None",
            },
          ]}
          onChange={(val) => setValues({ chartType: val })}
        />
      </Grid.Col>
      <Grid.Col span={12}>
        <Text size={"sm"}>Options</Text>
      </Grid.Col>
      {answers.map((option, index) => (
        <Grid.Col
          span={12}
          sx={{
            "&:hover": {
              "&>*:first-child": {
                opacity: 1,
                right: 36,
              },
            },
          }}
        >
          <CloseButton
            color={"red"}
            variant={"light"}
            sx={{
              position: "absolute",
              float: "right",
              marginTop: "4px",
              right: 50,
              zIndex: 99,
              transition: "300ms",
              opacity: 0,
            }}
            onClick={() => {
              if (answers.length <= 2) {
                showNotification({
                  title: "Failed to remove option",
                  message: "You must have at least 2 answers",
                  color: "red",
                });
                return;
              }
              setAnswers(answers.filter((opt, ind) => index !== ind));
            }}
          />
          <TextInput
            value={option.field_value}
            onChange={(event) => {
              let newanswers = [...answers];
              newanswers[index] = { field_value: event.currentTarget.value };
              setAnswers(newanswers);
            }}
            placeholder={`Option ${index + 1}`}
            variant="filled"
            error={
              answers.indexOf(option) !== index && option.length
                ? "Value is duplicated! only the first value will be considered."
                : null
            }
          />
        </Grid.Col>
      ))}
      <Grid.Col span={12}>
        <Button
          leftIcon={<IconPlus size={16} />}
          onClick={() => {
            setAnswers([...answers, ""]);
          }}
        >
          Add Option
        </Button>
      </Grid.Col>
    </Grid>
  );
}
